import chunk from "lodash/chunk";
import { Inventory } from "src/interfaces/inventory.interface";
import { MaximumBatchSize } from "src/config/firestore";
import firestore from "src/apiService/firestore";
import storage from "src/apiService/storage";
import { stampNormalizedMatchFields } from "src/utils/normalizeMatchKey";

const db = firestore();

export const deleteUploadsApi = async (ids: string[]) => {
  if (!ids.length) return;

  for (const c of chunk(ids, MaximumBatchSize)) {
    const batch = db.batch();
    for (const id of c) {
      const doc = db.collection("Uploads").doc(id);
      batch.delete(doc);
    }
    await batch.commit();
  }
};

export async function deleteDownloadsDocuments(ids: string[]) {
  if (!ids.length) return;

  for (const c of chunk(ids, MaximumBatchSize)) {
    const batch = db.batch();
    for (const id of c) {
      const doc = db.collection("Downloads").doc(id);
      batch.delete(doc);
    }
    await batch.commit();
  }
}

export async function getJSONFileApi(filename: string) {
  const storageRef = storage().ref(filename);
  const url = await storageRef.getDownloadURL();
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(
      `Failed to fetch ${filename}: ${response.status} ${response.statusText}`
    );
  }
  return response.json();
}

export async function markDownloadViewed(downloadId: string) {
  const ref = db.collection("Downloads").doc(downloadId);
  await ref.set({ new: false }, { merge: true });
}

export async function createUploadApi(uploadDoc) {
  const ref = db.collection("Uploads").doc();
  const id = ref.id;
  await ref.set({ ...uploadDoc, id });
  return id;
}

export async function uploadInventoryApi(inventory) {
  const ref = db.collection("Inventory").doc();
  const id = ref.id;
  await ref.set(stampNormalizedMatchFields({ ...inventory, id }));
  return id;
}

export async function uploadInventoryItems(items: Inventory[]): Promise<void> {
  if (!items.length) return;
  for (const c of chunk(items, MaximumBatchSize)) {
    const batch = db.batch();
    for (const item of c) {
      const doc = item.id
        ? db.collection("Inventory").doc(item.id)
        : db.collection("Inventory").doc();
      batch.set(doc, stampNormalizedMatchFields({ ...item, id: doc.id }));
    }

    await batch.commit();
  }
}
